<template>
  <span class="stripe-status-tag" :class="`stripe-status-tag--${tone}`">
    {{ label }}
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    tone: {
      type: String,
      default: 'neutral'
    }
  }
}
</script>

<style scoped>
.stripe-status-tag {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  min-height: 22px;
  padding: 2px 8px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.stripe-status-tag--success {
  color: var(--success-color);
  background: rgba(16, 185, 129, 0.12);
}

.stripe-status-tag--warning {
  color: var(--warning-color);
  background: rgba(245, 158, 11, 0.14);
}

.stripe-status-tag--error {
  color: var(--error-color);
  background: rgba(239, 68, 68, 0.12);
}

.stripe-status-tag--info {
  color: var(--info-color);
  background: rgba(59, 130, 246, 0.1);
}

.stripe-status-tag--neutral {
  color: var(--text-color-secondary);
  background: var(--bg-row-hover);
}
</style>
